/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/CollectionHistory/Content"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite,'--bc-2-Z1Yf8zk': dtColorsNeutral200,'--btlr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-8-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-9-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-10-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Collection history"
/>
</div>
{children}
</React.Fragment>)
}